import { parse } from './parser'
import { type MinidownNode, MinidownNodeType } from './nodes'

/**
 * Strips all Minidown from the source.
 *
 * @param source
 */
export function stripMinidown(source: string): string {
  return visit(parse(source))
}

/**
 * The visitor.
 */
function visit(node: MinidownNode): string {
  switch (node.type) {
    case MinidownNodeType.Text:
      return node.value
    case MinidownNodeType.Root:
    case MinidownNodeType.Emphasis:
    case MinidownNodeType.Strong: {
      return node.children.reduce((prev, next) => prev + visit(next), '')
    }
    /* v8 ignore next 2 */
    default:
      return ''
  }
}
